<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 数据筛选 -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="留言人" prop="nickname">
        <el-input v-model="queryParams.nickname" placeholder="请输入留言人" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="ip信息" prop="ip">
        <el-input v-model="queryParams.ip" placeholder="请输入ip地址或来源" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="登录设备" prop="deviceName">
          <el-input v-model="queryParams.deviceName" placeholder="请输入用户名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="操作系统" prop="os">
          <el-input v-model="queryParams.os" placeholder="请输入用户名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="代理名称" prop="agentName">
          <el-input v-model="queryParams.agentName" placeholder="请输入用户名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="留言内容" prop="messageContent">
        <el-input v-model="queryParams.messageContent" placeholder="请输入留言内容" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="留言时间" >
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格操作 -->
    <el-row :gutter="10"  class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:message:remove']" type="danger" plain size="mini" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">批量删除</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 表格展示 -->
    <el-table v-loading="loading" :data="messageList" @selection-change="selectionChange" >
      <!-- 表格列 -->
      <el-table-column type="selection" width="55" />
      <el-table-column prop="avatar" label="头像" align="center" width="80">
        <template slot-scope="scope">
          <img :src="scope.row.avatar" width="40" height="40" alt="" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="留言人" align="center" width="100" :show-overflow-tooltip="true"/>
      <el-table-column prop="messageContent" label="留言内容" align="center" min-width="250px" :show-overflow-tooltip="true" />
      <el-table-column prop="deviceType" label="设备类型" align="center" width="90px" :show-overflow-tooltip="true" />
      <el-table-column prop="deviceName" label="设备名称" align="center" min-width="130px" :show-overflow-tooltip="true" />
      <el-table-column prop="os" label="操作系统" align="center" min-width="110px"/>
      <el-table-column prop="agentType" label="代理类型" align="center" min-width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="agentName" label="代理名称" align="center" min-width="130px" :show-overflow-tooltip="true" />
      <el-table-column prop="ipAddress" label="ip地址" align="center" width="130"/>
      <el-table-column prop="ipSource" label="ip来源" align="center" min-width="100" :show-overflow-tooltip="true"/>
      <el-table-column prop="createTime" label="留言时间" width="170px" align="center">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <!-- 列操作 -->
      <el-table-column label="操作" width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-hasPermi="['system:message:remove']" size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { getMessageList, removeMessage } from "@/api/message/message";
export default {
  created() {
    this.getList();
  },
  data: function() {
    return {
      loading: true,
      showSearch:true,
      deleteFlag: false,
      // 非多个禁用
      multiple: true,
      messageIds: [],
      messageList: [],
      queryParams: {
        current: 1,
        size: 10,
        nickname: null,
        ip: null,
        deviceName: null,
        os: null,
        agentName: null,
        messageContent: null,
        startTime: null,
        endTime: null
      },
      dateRange: [],
      total: 0
    };
  },
  methods: {
    selectionChange(selection) {
      this.messageIds = selection.map(item => item.messageId);
      this.multiple = !selection.length;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.queryParams.startTime=undefined;
      this.queryParams.endTime=undefined;
      this.resetForm("queryForm");
      this.handleQuery();
    },
    handleDelete(row) {
      let ids = this.messageIds;
      if (row.messageId) {
        ids = [row.messageId];
      }
      this.$modal.confirm('是否确认删除留言ID为"' + ids + '"的数据项？').then(function() {
          return removeMessage(ids);
        }).then(() => {
          this.getList();
        }).catch(() => {});
    },
    getList() {
      if( Array.isArray(this.dateRange) && this.dateRange.length>0){
        this.queryParams.startTime=this.dateRange[0];
        this.queryParams.endTime=this.dateRange[1];
      }
      getMessageList(this.queryParams).then(res => {
        this.messageList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    }
  }
};
</script>
